import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { spacing, getFontTokenStyle } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label `
  box-sizing: border-box;
  margin-bottom: ${spacing(2)};
  display: inline-block;
  ${getFontTokenStyle('label', 'medium')};
`;
const Label = withExtra((_a) => {
    var { htmlFor, children } = _a, other = __rest(_a, ["htmlFor", "children"]);
    return (React.createElement(StyledLabel, Object.assign({ htmlFor: htmlFor }, other), children));
}, { name: 'Label' });

export { Label };
//# sourceMappingURL=Label.js.map
